import Box from '@mui/material/Box'
import vhsBackground from 'assets/vhs_background_frame_transparent.png'
import AutoBadge from 'components/core/AutoBadge'
import AnimatedBadge from 'components/core/AnimatedBadge'
import UnwatchedBadge from 'components/core/UnwatchedBadge'

const ReclipPreview = ({ reclip }) => {
  const color1 = reclip.background_color1
  const color2 = reclip.background_color2
  const hasCoverPhoto = !!reclip?.cover_photo

  return (
    <Box
      sx={{
        width: 100,
        height: 150,
        background: hasCoverPhoto
          ? undefined
          : `url(${vhsBackground}) center/cover no-repeat, linear-gradient(to top, ${color1}, ${color2})`,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        textAlign: 'center',
        textTransform: 'uppercase',
        fontWeight: 700,
        position: 'relative',
      }}
    >
      {hasCoverPhoto && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            borderRadius: 2,
            backgroundImage: `url(${reclip.cover_photo.url})`,
            backgroundSize: 'cover',
          }}
        />
      )}
      <AutoBadge
        reclip={reclip}
        sx={{ position: 'absolute', top: 4, left: 4, zIndex: 1 }}
      />
      <AnimatedBadge
        reclip={reclip}
        size={28}
        sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}
      />
      <UnwatchedBadge
        reclip={reclip}
        size={12}
        sx={{ position: 'absolute', bottom: 6, left: 6, zIndex: 1 }}
      />
    </Box>
  )
}

export default ReclipPreview
